export default __webpack_public_path__ + "static/media/demo.31d776ae.png";